import { Divider } from '@repo/editor/src/components/utilities/styles';
import { H5 } from '@repo/ui/components/Typography';
import { themeStyle } from '@repo/ui/theming';
import styled from 'styled-components';

import { FlexColumn, FlexRow } from 'styles/layouts';

export const Wrapper = styled(FlexColumn)<{ isOpen: boolean }>`
  width: 288px;
  padding: 12px;
  height: 100%;
  position: fixed;
  top: 0;
  bottom: 0;

  transition: all 0.3s linear 0s;
  transform: translateX(${({ isOpen }) => (isOpen ? '0' : '-100')}%);
  background: ${themeStyle.varBackgroundAlt};

  z-index: ${themeStyle.zIndexS9};
`;

export const Backdrop = styled.div<{
  state: { closing: boolean; isOpen: boolean };
}>`
  height: 100%;
  width: 100%;
  position: fixed;
  top: 0;
  z-index: ${themeStyle.zIndexS9};

  transition: background-color ease-in-out 0.25s;
  backdrop-filter: blur(4px);
  -webkit-backdrop-filter: blur(4px);

  background-color: ${({ state }) =>
    state.closing || !state.isOpen ? 'rgba(0, 0, 0, 0)' : 'rgba(0, 0, 0, 0.6)'};

  html[data-theme='dark'] &&,
  .dark && {
    ${({ state }) =>
      state.closing || !state.isOpen
        ? 'rgba(0, 0, 0, 0)'
        : 'rgba(0, 0, 0, 0.4)'};
  }
`;

export const Content = styled.div`
  overflow-y: auto;
  flex: auto;
`;

export const LogoContainer = styled.div`
  padding-bottom: 24px;
`;

export const SearchContainer = styled.div`
  padding-bottom: 24px;
`;

export const AuthButtonsContainer = styled.div`
  padding-top: 12px;
`;

export const LinksColumnLabel = styled(H5)`
  padding: 8px;
  color: inherit;
  cursor: pointer;
  width: 100%;
`;

export const LinkWrapper = styled(FlexRow)`
  align-items: center;
  gap: 2px;
  justify-content: flex-start;
  width: 100%;
  color: ${themeStyle.varInkMain};

  &:hover {
    color: ${themeStyle.varInkMedium};
  }
`;

export const SideMenuDivider = styled(Divider)`
  margin: 8px 0;
`;

export const MenuItemsWrapper = styled.div<{ visible: boolean }>`
  display: ${({ visible }) => (visible ? 'block' : 'none')};
`;
